module.exports = __webpack_public_path__ + "img/vibe.a348f668.svg";